import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Input,
  PillContainer,
  Button,
  Icon,
} from '@salesforce/design-system-react';
import { addToast } from '../../actions';

class PillJourney extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pillOptions: props.pillOptions,
      addEmailName: '',
    };
  }

  setAddEmailName = (vv) => {
    this.setState({ addEmailName: vv });
  };

  addToPillOptions = () => {
    let option = {},
      optionsLength = this.state.pillOptions.length,
      regex = /@salesforce.com$/;
    let sameAsJourneyEmail =
      this.isProd() &&
      this.state.addEmailName
        .toLowerCase()
        .indexOf(this.props.journeyEmail.toLowerCase()) !== -1;

    if (regex.exec(this.state.addEmailName) == null) {
      this.props.addToast({
        labels: {
          heading: 'Only salesforce emails are allowed.',
        },
        variant: 'error',
      });
      return;
    }
    if (sameAsJourneyEmail) {
      this.props.addToast({
        labels: {
          heading: 'Email cannot be same as your email.',
        },
        variant: 'error',
      });
      return;
    }

    let newId = optionsLength + 1;

    option['id'] = newId.toString();
    option['label'] = this.state.addEmailName;
    option['icon'] = <Icon category="standard" name="email" title="Email" />;

    let newOptions = this.state.pillOptions;
    newOptions.push(option);

    this.setState({ pilloptions: newOptions });
    this.setState({ addEmailName: '' });

    this.props.setPillOptions(this.state.pillOptions);
  };

  isProd = () => {
    return process.env.NODE_ENV === 'production';
  };

  onRequestRemovePill = (event, data) => {
    let newOptions = this.state.pillOptions.filter(
      (option) => option.id !== data.option.id
    );
    this.setState({ pillOptions: newOptions });
    this.props.setPillOptions(newOptions);
  };
  render() {
    return (
      <div>
        <div className="slds-grid slds-m-vertical_medium">
          <div className="slds-col">
            <Input
              label="Invite Contributors by Email"
              value={this.state.addEmailName}
              onChange={(e) => this.setAddEmailName(e.target.value)}
            />
          </div>
          <div className="slds-col">
            <Button
              variant="brand"
              className="slds-m-left_small"
              style={{ marginTop: '1.5rem' }}
              onClick={() => this.addToPillOptions()}
            >
              Add Contributor
            </Button>
          </div>
        </div>
        <div>
          <div className="slds-grid slds-grid_vertical-align-start">
            <PillContainer
              id="pill-container-with-icons"
              options={this.state.pillOptions}
              onClickPill={null}
              onRequestRemovePill={this.onRequestRemovePill}
            />
          </div>
        </div>
      </div>
    );
  }
}

PillJourney.propTypes = {
  pillOptions: PropTypes.array.isRequired,
};
const mapDispatchToProps = (dispatch) => ({
  addToast: (toast) => dispatch(addToast(toast)),
});
export default connect(null, mapDispatchToProps)(PillJourney);
